/** Namespace chunks. Critical namespaces are static; every other file loads on demand. */
import common from '@/locales/en/common.json';
import nav from '@/locales/en/nav.json';
import app from '@/locales/en/app.json';

export const criticalMessages = {
  common,
  nav,
  app,
} as const;

const loaders: Record<string, () => Promise<{ default: Record<string, unknown> }>> = {
  "aiTutor": () => import('@/locales/en/aiTutor.json'),
  "assignments": () => import('@/locales/en/assignments.json'),
  "course": () => import('@/locales/en/course.json'),
  "courses": () => import('@/locales/en/courses.json'),
  "daily": () => import('@/locales/en/daily.json'),
  "games": () => import('@/locales/en/games.json'),
  "gradebook": () => import('@/locales/en/gradebook.json'),
  "home": () => import('@/locales/en/home.json'),
  "learn": () => import('@/locales/en/learn.json'),
  "library": () => import('@/locales/en/library.json'),
  "login": () => import('@/locales/en/login.json'),
  "quizzes": () => import('@/locales/en/quizzes.json'),
  "schoolhouse": () => import('@/locales/en/schoolhouse.json'),
  "student": () => import('@/locales/en/student.json'),
};

export function loadNamespaceModule(namespace: string): Promise<{ default: Record<string, unknown> }> | null {
  const load = loaders[namespace];
  return load === undefined ? null : load();
}

